<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-body modal-content">                     
                            <div class="">
                                <div class="title_block">
                                    <h3 class="mb-0 font-active" v-if="!['pendant', 'earring'].includes(moduleSubType)">Side Stone Quantity & Shape</h3>
                                    <h3 class="mb-0 font-active" v-if="['pendant', 'earring'].includes(moduleSubType)">Accent Stone Quantity & Shape</h3>
                                    <span @click="notOpenModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                                </div>
                                <div class="mt-3">

                                    <div class="image_block text-center my-3">
                                        <!-- <img src="/settingactive/round.svg"> -->
                                        <!-- <img width="115" height="72" :src="'/settingactive/' + lowercase(item.side_stone_shape) + '.svg'"> -->
                                        <img v-for="(imageName, index) in imageNames" :key="index" width="115" height="72" :src="`/settingactive/${imageName}.svg`" :alt="imageName" />
                                    </div>
                                   
                                    <p class="text-center">
                                        Quantity : <b>{{ item.num_lots || item.side_stone.diamonds}}</b><br />
                                        Shape : <b>{{ item.side_stone_shape }}</b>
                                    </p>

                                    <p class="mb-0">Accent diamonds are smaller diamonds that are placed around or next to the centerstone in a {{moduleSubType}} to enhance its look. The number and shape of these side stones can enhance the look of a design.</p>
                                    
                                    <!-- below one for earring &  pendant only -->
                                    <p class="text mb-0 mt-1" v-if="moduleSubType === 'earring' || 'pendant'">*The number of accent diamonds may vary as per the carat weight of the center diamond.</p>
                                    <!-- rest of content -->
                                    <p class="text mb-0 mt-1" v-else>*The number of accent diamonds may vary as per the {{detailData}} size & center stone weight.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Teleport>
        </div>
    </div>
</template>

<script setup>
    const flagShowModal = ref(false);
    const sideQuantity = ref(null);
    const props = defineProps(['item', 'title','moduleSubType','detailData','ringBox']);
    const imageNames = ref([]);
    const emit = defineEmits(['close']);

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
            const modalElement = sideQuantity.value;
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
            }
        });
    };

    const hideModal = () => {
        const modalElement = sideQuantity.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };


    const processSideStoneShapes = () => {
        const shapeString = props.item.side_stone_shape || '';
        imageNames.value = shapeString
            .toLowerCase()                  // Convert to lowercase
            .replace(/\s+/g, '')            // Remove all spaces
            .split(',')                     // Split by comma
            .map(name => name.trim());      // Trim each part
    };


    onMounted(() => {
        processSideStoneShapes();
    });
</script>



<style scoped>
.text{
    font-size: 14px;
    font-style: italic;
    color: #909090;
}
.largesvg {
    transform: scale(1.3);
    }

.img_box{
    height: 130px;
}

.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p {
    font-size: 16px;
    color: #606060;
}
.title_block span {
    cursor: pointer;
}
.m-info {
    margin: 10px 0;
}
h3{
    font-size: 20px;
}

@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }
    .text{
        font-size: 12px;
    }
}
</style>
